module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Regular-d28966432dd50d59cf6b6bd0558cf0e4.svg";